

import { Component, Mixins, VModel, Emit } from 'vue-property-decorator';
import IBDialog from '@/components/Dialog/IBDialog.vue';
import { DialogVariant } from '@/components/Dialog/types';
import IBPaymentList from '@/components/IBPayment/IBPaymentList.vue';
import PaymentRequirementsIncomingLoader from '../../mixins/Incoming/Unprocessed/PaymentRequirementsIncomingLoader';

@Component({
	components: {
		IBDialog,
		IBPaymentList
	}
})
export default class PaymentRequirementsListDialog extends Mixins(
	PaymentRequirementsIncomingLoader
) {

	@VModel({ type: Boolean })
	model!: boolean

	beforeDestroy() {
		this.setPaymentRequirementsList([]);
	}

	get DialogVariant(): typeof DialogVariant {
		return DialogVariant;
	}

	@Emit("confirmed")
	emitConfirmed() {}

}

